module.exports = __webpack_public_path__ + "img/lightGreyCalendar.d69e763d.svg";